import { useState, useEffect } from 'react';
import axiosInstance from '../api/commonApi';

// Use axios instances if we have multiple base urls to call instead of setting base url here.
// axios.defaults.baseURL = 'https://jsonplaceholder.typicode.com';

const useAxios = (params, shouldFetchInitially = true) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shouldFetch, setShouldFetch] = useState(shouldFetchInitially);

  const fetchData = async (options) => {
    setLoading(true);
    try {
      const res = await axiosInstance(options);
      setResponse(res.data);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shouldFetch) {
      fetchData(params);
    } else {
      setLoading(false);
    }
  }, [shouldFetch]);

  return { response, error, loading, setShouldFetch, setResponse };
};

export default useAxios;
